export default {
    title: "Suporte",
    description:
        "Em caso de dúvidas, entre em contato com o suporte via whatsapp ou consulte nossa central de ajuda.",
    service_hours_title: "Horário de Atendimento:",
    service_hours_description:
        "Segunda a sexta-feira das 09:00 às 12:00 e das 13:00 às 17:00",
    whatsapp_button: "Atendimento via Whatsapp",
    help_center_button: "Ver central de ajuda",
    emergency_title: "Plantão:",
    emergency_description:
        "Para solicitações emergenciais fora do nosso horário de atendimento, favor preencher o formulário de plantão.",
    emergency_button: "Formulário de Plantão",
};
